import { render, staticRenderFns } from "./RecentTransactions.vue?vue&type=template&id=046b4f7f&scoped=true&"
import script from "./RecentTransactions.vue?vue&type=script&lang=js&"
export * from "./RecentTransactions.vue?vue&type=script&lang=js&"
import style0 from "./RecentTransactions.vue?vue&type=style&index=0&id=046b4f7f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "046b4f7f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VBtn,VIcon,VProgressCircular})
